/**
 * 語言切換（骨架版 —— P1-4a 會換成 `@coeldery/locale-switcher` 模組）
 * ⚠️ 文字一律由 i18n 出（唔准 hardcode）。
 */
import { useTranslation } from 'react-i18next';

const LANGS = ['zh-HK', 'en', 'zh-CN'] as const;
type Lang = (typeof LANGS)[number];

export function LocaleSwitcher() {
  const { i18n } = useTranslation();
  return (
    <select
      aria-label="language"
      value={i18n.resolvedLanguage ?? 'zh-HK'}
      onChange={(e) => void i18n.changeLanguage(e.target.value as Lang)}
    >
      {LANGS.map((l) => (
        <option key={l} value={l}>
          {l}
        </option>
      ))}
    </select>
  );
}
